import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../Contexts/AlertContext";
import { authFileRequest, fileRequest, props } from "../APIs/api";
import AuthContext from "../Contexts/AuthContext";
import AlertTypes from "../Enums/AlertTypes";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NavContext from "../Contexts/NavContext";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { Login, loginWithTelebir } from "../APIs/AuthAPI";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


const SignIn = () => {

    const {currentOrder, updateCurrentOrder, openAlert, setWaiting, setShowAlert} = useContext(AlertContext);
    const {isLoggedIn, loggedUser, setLoggedUser, setLoggedIn, setCookie, cookies, removeCookie, authWaiting, localData} = useContext(AuthContext);
    const {selectNav} = useContext(NavContext);

    const navigate = useNavigate();
    const [passwordVisibility, setPasswordVisibility] = useState<Boolean>(false);
    const [inputs, setInputs] = useState<any>({
        phone: "",
        password: ""
    });

    useEffect(() => {

        if(isLoggedIn || loggedUser) {
            navigate("/home"); (selectNav && selectNav("home"));
        }

    }, []);

    const submitForm = async (event: any) => {
        event.preventDefault();

        let phone_validator = /[a-zA-Z\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-]/g;

        setTimeout(() => {setWaiting(true);}, 1);

        try {

            if(phone_validator.test(inputs.phone)) {
                throw new Error("Phone should not contain special characters and alphabet characters.");
            }

            let response = await Login(`+251${inputs.phone}`, inputs.password);
            setLoggedUser(response);
            setCookie("login_token", response.Token, { path: "/", secure: true, maxAge: 900 });
            setLoggedIn(true);

            navigate("/account");
        } catch (error: any) {
            openAlert(AlertTypes.Error, error.message);
        }

        setTimeout(() => {setWaiting(false);}, 1);

    }

    const continueWithTelebir = async () => {

        try {

            window.handleinitDataCallback = async (token: any) => {
                let response = await loginWithTelebir(token);
                setLoggedUser(response);
                setCookie("login_token", response.Token, { path: "/", secure: true, maxAge: 900 });
                setLoggedIn(true);
                navigate("/account");
            };
    
            let obj = JSON.stringify({
                functionName: "js_fun_h5GetAccessToken",
                params: {
                    appid: "1250715428992001",
                    functionCallBackName: "handleinitDataCallback",
                },
            });
    
            window.consumerapp.evaluate(obj);

        } catch(error: any) {
            openAlert(AlertTypes.Error, error.message);
        }

    }

    const inputChange = (event: any) => {
        setInputs((npt: any) => ({...npt, [event.target.name]: event.target.value}))
    }

    return (
        <div className="w-100 px-3 pt-3" style={{position: "relative"}}>
            <h1 className="card-title text-center mb-2">Sign In</h1>
            <p className="lead mb-5 text-center">Sing into your profile.</p>

            <span className="card-title lead"><b> Phone Number</b></span>
            <div className="d-flex nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <span className="card-subtitle me-2">+251</span>
                <input type="text" value={inputs.phone} name="phone" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Your Account Number" />
            </div>

            <span className="card-title lead"><b>Password</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={passwordVisibility ? "text" : "password"} name="password" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Your Account Password" />
                <button className="btn btn-sm" onClick={() => {setPasswordVisibility(!passwordVisibility)}}>
                    {passwordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <button className="nuwa-white-btn py-2 px-2 mb-3 text-center w-100" onClick={ submitForm } >
                Sign In
            </button>

            {
                window.consumerapp && (
                    <>
                        <div className="nuwa-card d-flex justify-content-center nuwa_panel mb-3" 
                            style={{borderRadius: "20px", cursor: "pointer", padding: "13px"}}
                            onClick={continueWithTelebir}
                        >
                            <img src="/images/Telebirr.png" alt="telebirr logo" className="me-3" style={{width: "70px"}} />
                            <span className="ms-3 fs-3">Continue with telebirr</span>
                        </div>
                    </>
                )
            }

            <div className="nuwa-card d-flex justify-content-center nuwa_panel mb-3" 
                style={{borderRadius: "20px", cursor: "pointer", padding: "13px"}}
                onClick={() => {
                    navigate("/create_account");
                    (selectNav && selectNav("order"))
                }}
            >
                <img src="/images/logo_white.png" alt="nuwa logo" className="me-3" style={{width: "40px"}} />
                <span className="ms-3 fs-3">Sign Up</span>
            </div>

        </div>
    );

};

export default SignIn;